import { render, staticRenderFns } from "./tbfx2.vue?vue&type=template&id=11e99f07"
import script from "./tbfx2.vue?vue&type=script&lang=js"
export * from "./tbfx2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports